import React from 'react';

import { RecognitionReviewAndPayTemplate } from '@hero/templates';

function NewRecognitionReviewAndPay() {
  return <RecognitionReviewAndPayTemplate />;
}

export { NewRecognitionReviewAndPay };
